export const skillsData = [
  // Languages
  'Java',
  'Python',
  'C',
  'C++',
  'JavaScript',
  // Web Development
  'HTML',
  'CSS',
  'Angular',
  'React',
  'PHP',
  'Bootstrap',
  // Backend & Databases
  'Node.js',
  'Express',
  'MongoDB',
  'MySQL',
  'PostgreSQL',
  'Laravel',
  // Mobile Development
  'Kotlin',
  // Tools & Version Control
  'Git',
  'GitHub',
];
  